import { render, staticRenderFns } from "./SfContentCategory.vue?vue&type=template&id=04d0e95a&"
import script from "./SfContentCategory.vue?vue&type=script&lang=js&"
export * from "./SfContentCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports